import * as React from 'react';
import { Label } from '@fluentui/react/lib/Label';
import { Select } from 'formComponents/Select/Select';
import { AnredeLabel } from 'utils/labels';
import { ValueType } from 'react-select';
import { SelectOption } from 'formComponents/Select/types';

interface AnredeProps {
    disabled: boolean;
    value: string;
    onChange: (newValue: string) => void;
}

export const Anrede: React.FC<AnredeProps> = ({ value, disabled, onChange }) => {
    return (
        <>
            <Label>Anrede</Label>
            <Select
                name="anrede"
                isDisabled={disabled}
                value={
                    value
                        ? {
                              value,
                              label: AnredeLabel[value] || value,
                          }
                        : {
                              value: '',
                              label: '',
                          }
                }
                options={Object.keys(AnredeLabel).map((key) => ({
                    value: key,
                    label: AnredeLabel[key],
                }))}
                onChange={(option: ValueType<SelectOption, false>): void => {
                    onChange(option?.value || '');
                }}
            />
        </>
    );
};
